<template>
  <div>
    <div v-if="loading" class="text-gray-500">Chargement du log...</div>
    <div v-else-if="error" class="text-red-600">{{ error }}</div>

    <div v-else class="space-y-4 w-full">
        <pre class="bg-gray-100 text-sm p-3 whitespace-pre-wrap rounded overflow-x-auto">
        {{ filteredLog  }}
        </pre>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      error: null,
    }
  },
  computed: {
    filteredLog() {
        if (!this.levels || this.levels.length === 0) return this.data

        return this.data
        .split('\n')
        .filter(line => this.levels.includes(line.charAt(0)))
        .join('\n')
    }
  },
  props: {
    // logFileName: String,
    levels: Array // ['I', 'W', 'E']
  },
  async mounted() {
    this.deviceId = this.$route.params.deviceId;
    this.logFileName = this.$route.params.logFileName;
    try {
      const res = await fetch(
        `${process.env.VUE_APP_AZURE_FUNCTION_URL}/api/deviceLogFiles?code=${process.env.VUE_APP_AZURE_FUNCTION_CODE}&deviceId=${this.deviceId}&fileName=${this.logFileName}`, 
        {headers: { 'Authorization': `Bearer ${localStorage.getItem('auth_token')}` }}
        );
      if (!res.ok) throw new Error('Erreur lors du chargement')
      this.data = await res.text();
    } catch (err) {
      this.error = err.message || 'Erreur inconnue'
    } finally {
      this.loading = false
    }
  },
}
</script>
